/*
 * Ryan O'Dowd
 * 2025-07-08
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({globalScale, fonts, colors}) => {
  const tooltipStyles = {
    color: colors.lightGray,
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
    cursor: 'help',
  };

  return {
    container: {
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      minWidth: globalScale * 200,
      padding: globalScale * 8,
      borderRadius: globalScale * 16,
      borderWidth: globalScale * 4,
      borderColor: colors.primaryDark,
      backgroundColor: colors.primaryLight,
    },
    titleAndCostWrapper: {
      width: '100%',
      padding: globalScale * 8,
      borderRadius: globalScale * 8,
      borderWidth: globalScale * 2,
      borderColor: colors.lightGray,
      backgroundColor: colors.white,
    },
    titleText: {
      flexGrow: 1,
      fontFamily: fonts.secondaryBold,
      fontSize: globalScale * 20,
      color: colors.primary,
    },
    costText: {
      fontFamily: fonts.primary,
      fontSize: globalScale * 18,
      color: colors.primaryDark,
    },
    actionButtons: {
      flex: 1,
      width: '100%',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: globalScale * 8,
    },
    featuresContainer: {
      width: '100%',
      borderTopWidth: globalScale * 4,
      borderTopColor: colors.primaryDark,
      marginVertical: globalScale * 8,
    },
    featureWrapper: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      gap: globalScale * 8,
      paddingTop: globalScale * 16,
    },
    featureText: {
      fontSize: globalScale * 16,
      color: colors.white,
      display: 'inline',
    },
    tooltipStyles,
    linkStyles: {
      ...tooltipStyles,
      textDecorationStyle: 'solid',
      cursor: 'pointer',
    },
  };
};

export default getStyles;
